import React, { useState } from 'react';
import { Form, FormItemProps } from 'antd';
import { StyledInputNumber } from './styles';

export const parseCurrencyWithPlus = (
    value: string | undefined,
    setHasPlus: (v: boolean) => void,
): number => {
    if (!value) return 0;

    const trimmed = value.trim();

    const containsPlus = trimmed.includes('+');
    const isNegative = trimmed.startsWith('-');

    setHasPlus(containsPlus && !isNegative);

    const digits = trimmed.replace(/[^\d]/g, '');
    const number = Number(digits || 0);

    return isNegative ? -number : number;
};

export const formatCurrencyWithPlus = (
    value: number | undefined,
    hasPlus: boolean,
): string => {
    if (value === undefined || value === null) return '';

    const formatted = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    })
        .format(Math.abs(value) / 10)
        .concat('%');

    if (value < 0) return `-${formatted}`;
    if (hasPlus) return `+${formatted}`;

    return formatted;
};

export function StepperField(props: FormItemProps<number>) {
    const [hasPlus, setHasPlus] = useState(false);
    return (
        <Form.Item {...props} noStyle>
            <StyledInputNumber
                min={-Infinity}
                parser={(value) => parseCurrencyWithPlus(value, setHasPlus)}
                formatter={(value: number) =>
                    formatCurrencyWithPlus(value, hasPlus)
                }
            />
        </Form.Item>
    );
}
